export const downloadBlobResponse = (response, fallbackName = 'download.docx') => {
  if (!response || !response.blob) {
    return;
  }

  const { blob, headers } = response;
  let filename = fallbackName;
  const disposition = headers?.['content-disposition'] || headers?.get?.('content-disposition');

  if (disposition && typeof disposition === 'string') {
    const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
    const raw = match?.[1] || match?.[2];
    if (raw) {
      try {
        filename = decodeURIComponent(raw.replace(/\+/g, '%20'));
      } catch (_) {
        filename = raw;
      }
    }
  }

  const url = window.URL.createObjectURL(new Blob([blob]));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};
